import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
import './validation-message.scss';

export default function ValidationMessage(props: any) {

    const [validationMessage, setValidationMessage] = useState("");

    useEffect(() => {
        let message = "";
        if (props.question.validationMessage !== "" && props.question.validationMessage !== null && props.question.validationMessage !== undefined) {
            message = props.question.validationMessage;
        } else {
            if (props.overrideMessage !== "" && props.overrideMessage !== null && props.overrideMessage !== undefined) {
                message = props.overrideMessage;
            }

            if (message === "" && props.question.questionSetAnswerType.startRange !== null && props.question.questionSetAnswerType.startRange !== undefined && props.question.questionSetAnswerType.startRange !== "") {
                message = `Value must be between ${props.question.questionSetAnswerType.startRange} & ${props.question.questionSetAnswerType.endRange}`
            }
        }

        if (message === "") {
            message = "This field can't be empty";
        }

        setValidationMessage(message);

    }, [])

    return (
        <>
            <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> {validationMessage}</div>
        </>

    );
};